'use client';

import { CustomSpin } from '@components/Common/CustomSpin';
import { useCommonAuthProvider } from 'app/_modules/auth/providers/CommonAuthProvider/CommonAuthProvider';

import { Route } from 'next';
import { useRouter } from 'next/navigation';
import React, { useEffect } from 'react';

const IndexPage: React.FC = () => {
  const { loginWithRedirect, isLoading, isAuthenticated } = useCommonAuthProvider();
  const router = useRouter();

  useEffect(() => {
    if (isLoading) {
      return;
    }

    if (isAuthenticated) {
      router.push('/organizations' as Route);

      return;
    }

    loginWithRedirect();
  }, [isLoading]);

  return <CustomSpin />;
};

export default IndexPage;
